module.exports = "https://cdn.hellotech.com/client-assets/sign_a53e572e45c7e351f764a8951e5d0430.png";